import { Component } from '@angular/core';

@Component({
  selector: 'app-site-edit-page',
  templateUrl: './site-edit-page.component.html',
  styleUrls: ['./site-edit-page.component.scss']
})
export class SiteEditPageComponent {

}
